// ************
// Recipe Single View
// All Ingredients List (all steps included)
// ************
import { StepZutatList } from "@/types/baseTypes";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React from "react";
import RecipeIngredientTable from "./RecipeIngredientTable/RecipeIngredientTable";
import styles from "./RecipeIngredientList.module.scss";

interface RecipeIngredientListProps {
  ingredientsList: StepZutatList;
}

function RecipeIngredientList({ ingredientsList }: RecipeIngredientListProps) {
  const { portionsgroesse, anzahl_portionen_big } = ingredientsList;
  const { getLabel } = useGlobalContext();
  const allIngredients = ingredientsList.zutaten_portion_big;

  return (
    <section className={`${styles["recipe-ingredient-list"]}`}>
      <p
        className="h4 mb-4"
        aria-level={2}
        role="heading"
      >{`${getLabel("ingredients_for")} ${
        portionsgroesse || anzahl_portionen_big + " " + getLabel("portions")
      }`}</p>
      <RecipeIngredientTable ingredients={allIngredients} hasBorder />
    </section>
  );
}

export default RecipeIngredientList;
